import React from 'react'
import PropTypes from 'prop-types'
import { Badge } from "components-design-system"
import './RegistryCellRenderer.scss'

// api
import { useGetRegistries } from 'api/hooks/enum'

const RegistryCellRenderer = ({
  value,
}) => {
  const { data: registries } = useGetRegistries()

  return <div className="registry-cell-renderer">
    <Badge.Registry
      value={value}
      registries={registries}
    />
  </div>
}

RegistryCellRenderer.propTypes = {
  value: PropTypes.string,
}

export default RegistryCellRenderer